// extracted by mini-css-extract-plugin
export default {"invalid":"PruebaEdit_invalid__k4n7k","spinnerContainer":"PruebaEdit_spinnerContainer__RyVJu"};